import * as React from 'react';
import { SvgProps } from '../SvgGetter/SvgGetter';
import { Colors } from '../../../../styles/colors';

export const Utmatting: React.FC<SvgProps> = ({
	fill = 'white',
	pathFill = Colors.primaryTekst,
	stroke = Colors.primaryTekst,
	...props
}) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='100%'
		height='100%'
		viewBox='0 0 16 16'
		fill='none'
		{...props}
	>
		<g clipPath='url(#clip0_2074_15663)'>
			<path
				d='M1 8L6.5 6.5L5 9L8 11L5 14'
				stroke={stroke}
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M8.59906 0.599991C8.59906 0.267496 8.33157 0 7.99907 0C7.66658 0 7.39908 0.267496 7.39908 0.599991V2.59996C7.39908 2.93245 7.66658 3.19995 7.99907 3.19995C8.33157 3.19995 8.59906 2.93245 8.59906 2.59996V0.599991ZM5.02412 1.77497C4.78912 1.53998 4.40913 1.53998 4.17663 1.77497C3.94414 2.00997 3.94164 2.38996 4.17663 2.62246L5.37662 3.82244C5.61161 4.05744 5.99161 4.05744 6.2241 3.82244C6.4566 3.58744 6.4591 3.20745 6.2241 2.97495L5.02412 1.77497ZM11.824 2.62496C12.059 2.38996 12.059 2.00997 11.824 1.77747C11.589 1.54498 11.209 1.54248 10.9765 1.77747L9.77655 2.97745C9.54155 3.21245 9.54155 3.59244 9.77655 3.82494C10.0115 4.05744 10.3915 4.05994 10.624 3.82494L11.824 2.62496Z'
				fill={pathFill}
			/>
			<path
				d='M9.5 6.5L15 8'
				stroke={stroke}
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</g>
		<defs>
			<clipPath id='clip0_2074_15663'>
				<rect width='16' height='16' fill={fill} />
			</clipPath>
		</defs>
	</svg>
);
